// Shared helpers for rendering Salesforce display templates.

/**
 * Render an entity display string using the provided template (e.g. "{{Name}} ({{Account.Name}})").
 * Falls back to common name/id fields if no template value is produced.
 */
export function renderDisplay(entityData: any, template?: string): string {
  const rendered = applyTemplate(template, entityData);
  if (rendered) {
    return rendered;
  }
  const anyEntity = entityData as any;
  return anyEntity?.Name || anyEntity?.name || String(anyEntity?.id ?? anyEntity?.Id ?? 'Unknown');
}

function applyTemplate(template: string | undefined, entityData: any): string {
  if (!template?.trim()) {
    return '';
  }
  return template
    .replace(/{{\s*([^}]+)\s*}}/g, (_, expr) => {
      const value = resolvePath(entityData, expr.trim());
      return value === undefined || value === null ? '' : String(value);
    })
    .trim();
}

function resolvePath(entityData: any, path: string): any {
  if (!path) {
    return undefined;
  }
  return path.split('.').reduce((acc: any, part: string) => {
    if (acc === undefined || acc === null) {
      return undefined;
    }
    return acc[part];
  }, entityData);
}
